module.exports = __webpack_public_path__ + "static/DBDwall.adbcbb2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/apps/DBDwall/DBDwall.png
// module id = 719
// module chunks = 20187308965491 198549822570343 205611893827833